import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { useRoot } from 'context/RootContext';
import { ALERT_VARIANTS, LOCALIZATION_PAGES, API_ENDPOINTS, HTTP_VERBS } from 'utils/constants';

const useEndShift = () => {
  const path = `${API_ENDPOINTS.SHIFTS}/end`;
  const { t } = useTranslation(LOCALIZATION_PAGES.SHIFT);
  const { showNotification } = useRoot();
  const [{ result, loading, error }, endShift] = useApi(path, {
    initialFetch: false,
    verb: HTTP_VERBS.PUT,
  });

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('end_shift_fail'),
        },

        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  useEffect(() => {
    if (result) {
      showNotification({
        message: t('end_shift_success'),
      });
    }
  }, [result, showNotification, t]);

  return [{ result, loading }, endShift];
};

export default useEndShift;
